import React, { useState } from 'react';
import cn from 'classnames';
import styles from '../styles';
import { makeStyles, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const useStyles = makeStyles(styles);

const Text = ({ error, label, registration, inputProps = {}, type, passwordPeekable }) => {
  const classes = useStyles();
  const [passwordVisible, setPasswordVisible] = useState(false);

  const { readOnly } = inputProps;

  const InputElement = type === 'textarea' ? 'textarea' : 'input';
  const showPeek = type === 'password' && passwordPeekable;
  const inputType = showPeek && passwordVisible ? 'text' : type;

  const inputStyle = showPeek
    ? { paddingRight: 40, width: '100%', boxSizing: 'border-box' }
    : {
        // height: 27, // matching the Date input height
      };

  const inputEl = (
    <InputElement
      type={inputType}
      autoComplete={showPeek ? 'off' : undefined}
      className={cn(
        classes.input,
        classes.textInput,
        readOnly && classes.disabledInput,
      )}
      style={inputStyle}
      readOnly={readOnly}
      {...inputProps}
      {...registration}
    />
  );

  return (
    <div className={cn(classes.inputContainer)}>
      {label && (
        <p className={cn(classes.inputLabel, classes.fieldLabel)}>
          {label}
        </p>
      )}
      {showPeek ? (
        <div style={{ position: 'relative', width: '100%' }}>
          {inputEl}
          <IconButton
            type="button"
            size="small"
            aria-label={passwordVisible ? 'Hide password' : 'Show password'}
            onClick={() => setPasswordVisible(v => !v)}
            style={{
              position: 'absolute',
              right: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              padding: 6,
            }}
          >
            {passwordVisible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
          </IconButton>
        </div>
      ) : (
        inputEl
      )}
    </div>
  );
};

export default Text;
